import { useMemo } from 'react';
import { gql } from '@soundxyz/gql-string';
import type { FragmentType } from '@graphql/reactQuery';
import { DynamicFeePercentInfoFragmentDoc, getFragment } from '@graphql/reactQuery';

export type Percent = `${number}%`;

export const zeroPercent = '0%';

export const samFeePercent = '2.5%';
export const defaultFeePercent = '5%';

export const defaultFeePercentBPS = 500;

export function isValidPercent(str: string): str is Percent {
  return /^[0-9]+(\.[0-9]+)?%$/.test(str);
}

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment DynamicFeePercentInfo on Release {
    publicAffiliateFeePercent
    isFirstPhaseCompleted
    samConfig {
      id
      affiliateFeePercent
    }
  }
`);

export function useDynamicFeePercent({
  releaseInfo,
}: {
  releaseInfo: FragmentType<DynamicFeePercentInfoFragmentDoc>;
}) {
  const { publicAffiliateFeePercent, isFirstPhaseCompleted, samConfig } = getFragment(
    DynamicFeePercentInfoFragmentDoc,
    releaseInfo,
  );

  const samConfigAffiliateFeePercent = samConfig?.affiliateFeePercent;

  return useMemo(() => {
    if (isFirstPhaseCompleted && samConfigAffiliateFeePercent != null)
      return isValidPercent(samConfigAffiliateFeePercent)
        ? samConfigAffiliateFeePercent
        : zeroPercent;

    return publicAffiliateFeePercent && isValidPercent(publicAffiliateFeePercent)
      ? publicAffiliateFeePercent
      : zeroPercent;
  }, [isFirstPhaseCompleted, publicAffiliateFeePercent, samConfigAffiliateFeePercent]);
}
